interface TCAppConfigType {
  GET_TC_CANCEL_AMEND: string;
  TRANSACTION_CERTIFICATE_ENDPOINT: string;
  POST_TC_BASE_DETAILS_V4: string;
  GET_TC_BASE_DETAILS_V4: string;
  GET_TC_BUYERSSELLERS_DETAILS_V4: string;
  POST_BUYER_SELLER_DETAILS_V4: string;
  BUYERS_SELLER_DETAILS: string;
  GET_SHIPMENTS: string;
  GET_SHIPMENTS_LIST: string;
  GET_SHIPMENTS_NEW: string;
  GET_BUYERS_SELLER_DETAILS: string;
  GET_ORGANIC_FARM_CODE: string;
  GET_STANDARD_LABEL_GRADE: string;
  GET_COUNTRY_CODE: string;
  GET_STATE_CODE: string;
  GET_RAW_MATERIAL_CODE: string;
  GET_CBLICENSING_CODE: string;
  CERTIFIED_TRANSACTION_DASHBOARD: string;
  DECLARATION_SUBMIT_DETAILS: string;
  DECLARATION_SUBMIT_DETAILS_NEW: string;
  GET_LABEL_GRADE: string;
  GET_PRODUCT_CODE: string;
  GET_SC_CLAIMS_CODE: string;
  GET_PRODUCT_DETAIL_CODE: string;
  SHIPMENTS_ENDPOINT: string;
  CERTIFIED_PRODUCT_DETAILS_ENDPOINT: string;
  TC_STD_WEIGHT_INFO_ENDPOINT: string;
  COMPONENT_DETAILS_ENDPOINT: string;
  INPUT_TCPRODUCT_DETAILS_ENDPOINT: string;
  PRODUCT_WEIGHT_VALIDATE: string;
  COMPONENT_WEIGHT_VALIDATE: string;
  INPUT_TCCOMPONENTS_ENDPOINT: string;
  GET_TC_DETAILS: string;
  GET_TE_DETAILS: string;
  CERTIFIED_TRANSACTION_DASHBOARD_DTRACKIT: string;
  GET_DTRACKIT_TRANSACTIONS: string;
  DTRACKIT_BASE_ENDPOINT: string;
  DTRACKIT_BASE_ENDPOINT_V4: string;
  GET_DTRACKIT_STANDARD: string;
  GET_CERTIFIED_RAW_MATERIAL_CODES: string;
  GET_TC_BASE_DETAILS: string;
  GET_CERTIFIED_WEIGHT_INFO: string;
  GET_CERTIFIED_WEIGHT_INFO_CONSOLIDATED: string;
  GET_TC_BUYERSSELLERS_DETAILS: string;
  GET_INPUT_TC_PRODUCTDETAILS_INFO: string;
  GET_INPUT_TC_PRODUCTDETAILS_INFO_NEW: string;
  POST_INPUT_TC_PRODUCTDETAILS_INFO: string;
  GET_PRODUCT_RAWMATERIAL_INFO: string;
  GET_PRODUCT_RAWMATERIAL_INFO_NEW: string;
  GET_PRODUCT_RAWMATERIAL_INFO_LIST: string;
  GET_INPUT_COMPONENT_DETAILS_NEW: string;
  GET_INPUT_COMPONENT_DETAILS_LIST: string;
  GET_COMPONENT_DETAILS: string;
  GET_COMPONENT_DETAILS_LIST: string;
  GET_COMPONENT_DETAILS_NEW: string;
  GET_CB_LANDING_PAGE_COUNTRIES: string;
  GET_DECLARATION_SUBMIT_DETAILS: string;
  TC_DELETE_API: string;
  GET_DECLARATION_JSON_DETAILS: string;
  GET_CB_CO_CODE: string;
  GET_HISTORICAL_COUNTRY: string;
  GET_SUPPLIERS_CO_LIST: string;
  GET_FACILITY_PROCESS_CATEGORY_CODE: string;
  EDIT_TC_DETAILS: string;
  GET_TC_NO: string;
  GET_TC_NO_INPUT_REF: string;
  GET_TC_SUBMISSION_STATUS: string;
  GET_MATERIAL_LEDGER: string;
  GET_ML_CO_DETAILS: string;
  GET_ML_INVENTORY_UPDATES: string;
  GET_TC_STANDARD: string;
  GET_RAW_MATERIAL_SUMMARY: string;
  POST_ML_INVENTORY_UPDATES: string;
  GET_STANDARD_LABEL_GRADE_BY_TCSTANDARD: string;
  GET_USER_DETAILS: string;
  GET_DISABLE_TABS: string;
  TC_PREVIEW: string;
  TC_DOWNLOAD_DOCX: string;
  GET_STD_DETAILS_PDCT_INFO: string;
  GET_ATC_NO: string;
  GET_ATC_DETAILS: string;
  CHECK_ADMIN_API: string;
  TC_COMP_PROD_API: string;
  //v4 base
  GET_DISABLE_V4_TABS:string;
  // V4 DTrackIt endpoints
  GET_DTRACKIT_SC_NO_V4: string;
  GET_DTRACKIT_CO_NAME_V4: string;
  GET_SC_DTRACKIT_TRANSACTIONS_V4: string;
  GET_DTRACKIT_REF_CODE_V4: string;
  // V4 SC Query Parameters
  GET_SC_STATUS: string;
  GET_TC_STATUS: string;
  GET_RET_TC_STATUS: string;
  GET_SC_STATUS_V4: string;
  GET_SUSPENSION_REASON: string;
  GET_SC_STANDARD_VALUES: string;
  GET_STANDARD_WITHDRAWAL_REASON_VALUES: string;
  GET_CERTIFIED_ORGANIZATION_APPROVED_CLAIMS_VALUES: string;
  GET_ACCREDITATION_BODY: string;
  GET_SC_NON_MANDATORY_CRITERION_STANDARD_VALUES: string;
  GET_FACILITY_TYPE: string;
  GET_FACILITY_CB_OF_INDEPENDENTLY_CERTIFIED_SUBCONTRACTOR: string;
  //v4 tc
  GET_SHIPMENTS_ENDPOINT_V4: string; // New v4 GET endpoint
  POST_SHIPMENTS_ENDPOINT: string;
  //  New v4 Declaration APIs
  GET_DECLARATION_SUBMIT_DETAILS_V4: string;
  POST_DECLARATION_SUBMIT_DETAILS_V4: string;
  GET_SUBMISSION_STATUS_V4: string;
  GET_CERTIFIED_WEIGHT_INFO_V4: string;
  GET_LIST_PRODUCT_INFO_V4: string;
  GET_PRODUCT_INFO_V4: string;
  POST_PRODUCT_INFO_V4: string;
  GET_TC_STANDARD_V4: string;
  GET_TC_NO_v4: string;
  GET_CB_LANDING_PAGE_COUNTRIES_V4: string;
  EDIT_TC_DETAILS_V4: string;
  CERTIFIED_TRANSACTION_DASHBOARD_V4:string;
  GET_CERTIFIED_WEIGHT_INFO_CONSOLIDATED_V4: string;
  POST_TC_CANCEL_AMEND_V4: string;
  GET_BUYER_SELLER_SC_NO_V4: string;
  POST_CERTIFIED_WEIGHT_INFO_V4:string;
  //component v4
  COMPONENT_DETAILS_ENDPOINT_V4: string;
  GET_COMPONENT_DETAILS_LIST_V4: string;
  GET_COMPONENT_DETAIL_V4: string;
  GET_TC_SC_COMPONENT_DETAILS_V4: string;
  GET_TC_COMPONENT_NET_SHIPPING_WEIGHT_V4: string;
  //dtrackit v4
  GET_PRODUCT_CODE_V4: string;
  GET_STANDARD_LABEL_GRADE_V4:string;
  GET_PRODUCT_DETAIL_CODE_V4:string;
  GET_RAW_MATERIAL_CODE_V4:string;
  GET_COUNTRY_CODE_V4:string;
  GET_STATE_CODE_V4: string;
  GET_CERTIFIED_RAW_MATERIAL_CODES_V4: string;
  TC_DELETE_API_V4: string;
  TC_SUBMIT_DATA_V4: string;
  //incoming TC Details
  POST_INCOMING_DETAIL_V4:string;
  GET_INCOMING_DETAIL_V4:string;
  GET_INCOMING_DETAIL_LIST_V4:string;
  GET_INTERMEDIATE_DATA_V4:string;
  GET_INTERMEDIATE_WEIGHT_V4:string;
  GET_SC_BY_TEID_STANDARD: string;
  GET_RMDF_SEARCH: string;
  GET_SC_PRODUCT_CLAIMS_CATEGORY_V4: string;
  //declarations
  PREVIEW_TC_V4: string;
  GENERATE_WORD_TC_V4: string;
  //metric
  GET_METRIC_CODES : string;
  TC_UPLOAD_PDF: string;
  //ML report
  ML_OB_REPORT :string;
  ML_LATEST_BAL: string;
  ML_OB_REPORT_EXPORT: string;
}
const TE_TYPES: any = {
  TC: "v1/tc",
  TCV4: "v4/tc",
  SCV4: "v4/sc",
  SC: "sc",
  ML: "v1/ml",
};
export const TC_CREATE_ROUTE_CONFIG = {
  TRANSACTION_DETAILS: "/create-tc/transaction-certificate/",
  BUYER_SELLER_DETAILS: "/create-tc/seller-buyer-products/",
  SHIPMENT_DETAILS: "/create-tc/shipments/",
  TC_PRODUCT_DETAILS: "/create-tc/certified-products-components/",
  CERTIFIED_RAW_MATERIALS_STD_DETAILS: "/create-tc/tc-standard-weight/",
  TC_COMPONENTS_DETAILS: "/create-tc/component-details/",
  INPUT_TC_PRODUCT_DETAILS: "/create-tc/Input-tc-product-details/",
  INPUT_TC_COMPONENTS_DETAILS: "/create-tc/Input-tc-component/",
  DECLARATION_SUBMIT: "/create-tc/declaration-certification-body/",
};

export const TCAppConfig: TCAppConfigType = {
  GET_TC_CANCEL_AMEND: `${TE_TYPES.TC}/cancel-amend`,
  TRANSACTION_CERTIFICATE_ENDPOINT: `${TE_TYPES.TC}/post-tc-base-details`,
  POST_TC_BASE_DETAILS_V4: `${TE_TYPES.TCV4}/post-base-details-v4`,
  GET_TC_BASE_DETAILS_V4: `${TE_TYPES.TCV4}/get-base-details-v4`,
  GET_TC_BUYERSSELLERS_DETAILS_V4: `${TE_TYPES.TCV4}/get-buyer-seller-details-v4`,
  POST_BUYER_SELLER_DETAILS_V4: `${TE_TYPES.TCV4}/post-buyer-seller-details-v4`,
  BUYERS_SELLER_DETAILS: `${TE_TYPES.TC}/post-tc-buyersellerdetails`,
  GET_BUYERS_SELLER_DETAILS: `${TE_TYPES.TC}/get-tc-buyersellerdetails`,
  GET_TE_DETAILS: `${TE_TYPES.TC}/get-dtrackit-buyer-seller-details`,
  GET_SUPPLIERS_CO_LIST: `${TE_TYPES.TC}/get-co-tclist`,
  CERTIFIED_TRANSACTION_DASHBOARD_DTRACKIT: `${TE_TYPES.TC}/get-dtrackit-transactions`,
  CERTIFIED_TRANSACTION_DASHBOARD: `${TE_TYPES.TC}/get-tc-cblicensing-code`,
  DECLARATION_SUBMIT_DETAILS: `${TE_TYPES.TC}/post-declaration-submit-details`,
  DECLARATION_SUBMIT_DETAILS_NEW: `${TE_TYPES.TC}/submit-data`,
  SHIPMENTS_ENDPOINT: `${TE_TYPES.TC}/post-shipment-consignee-details-new`,
  GET_SHIPMENTS: `${TE_TYPES.TC}/get-shipment-consignee-details`,
  GET_SHIPMENTS_LIST: `${TE_TYPES.TC}/get-shipment-consignee-details-list`,
  GET_SHIPMENTS_NEW: `${TE_TYPES.TC}/get-shipment-consignee-details-new`,
  CERTIFIED_PRODUCT_DETAILS_ENDPOINT: `${TE_TYPES.TC}/post-productandrawmaterial-info-new`,
  TC_STD_WEIGHT_INFO_ENDPOINT: `${TE_TYPES.TC}/post-certified-weight-info`,
  COMPONENT_DETAILS_ENDPOINT: `${TE_TYPES.TC}/post-component-detail-new`,
  INPUT_TCPRODUCT_DETAILS_ENDPOINT: `${TE_TYPES.TC}/post-inputtcdetailsproduct-info-new`,
  PRODUCT_WEIGHT_VALIDATE: `${TE_TYPES.TC}/product-weight-validate`,
  COMPONENT_WEIGHT_VALIDATE: `${TE_TYPES.TC}/component-weight-validate`,
  INPUT_TCCOMPONENTS_ENDPOINT: `${TE_TYPES.TC}/post-inputcomponent-detail-new`,
  GET_TC_DETAILS: `${TE_TYPES.TC}/get-tc-base-details`,
  GET_ORGANIC_FARM_CODE: "OS",
  GET_STANDARD_LABEL_GRADE: "LG",
  GET_DTRACKIT_TRANSACTIONS: "CB-ITS",
  GET_COUNTRY_CODE: "CT",
  GET_STATE_CODE: "ST",
  GET_RAW_MATERIAL_CODE: "RM",
  GET_CBLICENSING_CODE: "CXF",
  GET_LABEL_GRADE: "LG",
  GET_PRODUCT_CODE: "PD",
  GET_SC_CLAIMS_CODE: "SCCLMS",
  GET_PRODUCT_DETAIL_CODE: "PDD",
  GET_FACILITY_PROCESS_CATEGORY_CODE: "PR",
  GET_TC_STANDARD: `${TE_TYPES.TC}/get-tc-standard`,
  DTRACKIT_BASE_ENDPOINT: `${TE_TYPES.TC}/get-dtrackit-ref-code`,
  DTRACKIT_BASE_ENDPOINT_V4: `${TE_TYPES.TCV4}/get-dtrackit-ref-code-v4`,
  GET_DTRACKIT_STANDARD: `${TE_TYPES.TC}/get-dtrackit-standard`,
  GET_CERTIFIED_RAW_MATERIAL_CODES: `${TE_TYPES.TC}/get-certified-raw-mat-codes`,
  GET_TC_BASE_DETAILS: `${TE_TYPES.TC}/get-tc-base-details`,
  GET_CERTIFIED_WEIGHT_INFO: `${TE_TYPES.TC}/get-certified-weight-info`,
  GET_CERTIFIED_WEIGHT_INFO_CONSOLIDATED: `${TE_TYPES.TC}/get-certified-weight-info-consolidated`,
  GET_TC_BUYERSSELLERS_DETAILS: `${TE_TYPES.TC}/get-tc-buyersellerdetails`,
  GET_INPUT_TC_PRODUCTDETAILS_INFO: `${TE_TYPES.TC}/get-inputtcdetailsproduct-info-list`,
  GET_INPUT_TC_PRODUCTDETAILS_INFO_NEW: `${TE_TYPES.TC}/get-inputtcdetailsproduct-info-new`,
  POST_INPUT_TC_PRODUCTDETAILS_INFO: `${TE_TYPES.TC}/post-productandrawmaterial-info-new`,
  GET_PRODUCT_RAWMATERIAL_INFO: `${TE_TYPES.TC}/get-productandrawmaterial-info`,
  GET_PRODUCT_RAWMATERIAL_INFO_NEW: `${TE_TYPES.TC}/get-productandrawmaterial-info-new`,
  GET_PRODUCT_RAWMATERIAL_INFO_LIST: `${TE_TYPES.TC}/get-productandrawmaterial-info-list`,
  GET_INPUT_COMPONENT_DETAILS_NEW: `${TE_TYPES.TC}/get-inputcomponent-detail-new`,
  GET_INPUT_COMPONENT_DETAILS_LIST: `${TE_TYPES.TC}/get-inputcomponent-detail-list`,
  GET_COMPONENT_DETAILS: `${TE_TYPES.TC}/get-component-detail`,
  GET_COMPONENT_DETAILS_LIST: `${TE_TYPES.TC}/get-component-detail-list`,
  GET_COMPONENT_DETAILS_NEW: `${TE_TYPES.TC}/get-component-detail-new`,
  GET_CB_LANDING_PAGE_COUNTRIES: `${TE_TYPES.TC}/get-buyer-country`,
  GET_DECLARATION_SUBMIT_DETAILS: `${TE_TYPES.TC}/get-declaration-submit-details`,
  TC_DELETE_API: `${TE_TYPES.TC}/delete-api-new`,
  GET_DECLARATION_JSON_DETAILS: `${TE_TYPES.TC}/get-json`,
  GET_CB_CO_CODE: `${TE_TYPES.TC}/get-cb-co-code`,
  GET_HISTORICAL_COUNTRY: `${TE_TYPES.TC}/get-dtrackit-buyer-country`,
  EDIT_TC_DETAILS: `${TE_TYPES.TC}/edit-tc`,
  GET_TC_NO: `${TE_TYPES.TC}/get-tc-no`,
  GET_TC_NO_INPUT_REF: `${TE_TYPES.TC}/get-tc-no-input-ref`,
  GET_TC_SUBMISSION_STATUS: `${TE_TYPES.TC}/get-submission_status`,
  GET_MATERIAL_LEDGER: `${TE_TYPES.ML}/get-material-ledger-data`,
  GET_ML_CO_DETAILS: `${TE_TYPES.ML}/get-dtrackit-buyer-seller-details`,
  GET_ML_INVENTORY_UPDATES: `${TE_TYPES.ML}/get-inventory-updates`,
  GET_RAW_MATERIAL_SUMMARY: `${TE_TYPES.ML}/get-rm-summary-data`,
  POST_ML_INVENTORY_UPDATES: `${TE_TYPES.ML}/post-inventory`,
  GET_STANDARD_LABEL_GRADE_BY_TCSTANDARD: `${TE_TYPES.TC}/get-dtrackit-standard`,
  GET_USER_DETAILS: `${TE_TYPES.TC}/get-user-data`,
  GET_DISABLE_TABS: `${TE_TYPES.TC}/get-disable-tabs`,
  TC_PREVIEW: `${TE_TYPES.TC}/get-preview-tc-details`,
  TC_DOWNLOAD_DOCX: `${TE_TYPES.TC}/generate-word-tc`,
  GET_STD_DETAILS_PDCT_INFO: `${TE_TYPES.TC}/get-std-details-pdct-info`,
  GET_ATC_NO: `${TE_TYPES.TC}/get-atc-no`,
  GET_ATC_DETAILS: `${TE_TYPES.ML}/get-atc-details`,
  CHECK_ADMIN_API: `${TE_TYPES.TC}/check-admin`,
  TC_COMP_PROD_API: `${TE_TYPES.TC}/get-component-detail-by-product`,
  // V4 DTrackIt endpoints
  GET_DTRACKIT_SC_NO_V4: `${TE_TYPES.SCV4}/get-dtrackit-sc-no-v4`,
  GET_DTRACKIT_CO_NAME_V4: `${TE_TYPES.SCV4}/get-dtrackit-co-name-v4`,
  GET_SC_DTRACKIT_TRANSACTIONS_V4: `${TE_TYPES.SCV4}/get-sc-dtrackit-transactions-v4`,
  GET_DTRACKIT_REF_CODE_V4: `${TE_TYPES.SCV4}/get-dtrackit-ref-code-v4`,
  // V4 SC Query Parameters
  GET_SC_STATUS: "SCSTS",
  GET_SC_STATUS_V4: "SCSTSV4",
  GET_SUSPENSION_REASON: "SR",
  GET_SC_STANDARD_VALUES: "SD",
  GET_STANDARD_WITHDRAWAL_REASON_VALUES: "WR",
  GET_CERTIFIED_ORGANIZATION_APPROVED_CLAIMS_VALUES: "SCCLMS",
  GET_ACCREDITATION_BODY: "CBAB",
  GET_SC_NON_MANDATORY_CRITERION_STANDARD_VALUES: "",
  GET_FACILITY_TYPE: "FT",
  GET_FACILITY_CB_OF_INDEPENDENTLY_CERTIFIED_SUBCONTRACTOR: "CXF",
  //v4 base
  GET_DISABLE_V4_TABS:`${TE_TYPES.TCV4}/get-disable-tabs-v4`,
  GET_BUYER_SELLER_SC_NO_V4:`${TE_TYPES.TCV4}/get-buyer-seller-sc-no-v4`,
  //v4 tc
  GET_TC_STATUS: "TCSTS",
  GET_RET_TC_STATUS: "RET",
  POST_SHIPMENTS_ENDPOINT: `${TE_TYPES.TCV4}/post-shipment-consignee-details-v4`,
  GET_SHIPMENTS_ENDPOINT_V4: `${TE_TYPES.TCV4}/get-shipment-consignee-details-v4`,
  POST_TC_CANCEL_AMEND_V4: `${TE_TYPES.TCV4}/cancel-amend-v4`,
  //  New v4 Declaration APIs
  GET_DECLARATION_SUBMIT_DETAILS_V4: `${TE_TYPES.TCV4}/get-declaration-submit-details-v4`,
  POST_DECLARATION_SUBMIT_DETAILS_V4: `${TE_TYPES.TCV4}/post-declaration-submit-details-v4`,
  GET_SUBMISSION_STATUS_V4: `${TE_TYPES.TCV4}/get-submission-status-v4`,
  //v4 standard weight info
  GET_CERTIFIED_WEIGHT_INFO_V4: `${TE_TYPES.TCV4}/get-certified-weight-info-v4`,
  POST_CERTIFIED_WEIGHT_INFO_V4:`${TE_TYPES.TCV4}/post-certified-weight-info-v4`,
  GET_CERTIFIED_WEIGHT_INFO_CONSOLIDATED_V4: `${TE_TYPES.TCV4}/get-certified-weight-info-consolidated-v4`,
  //v4 product
  GET_LIST_PRODUCT_INFO_V4: `${TE_TYPES.TCV4}/get-list-product-info-v4`,
  GET_PRODUCT_INFO_V4: `${TE_TYPES.TCV4}/get-product-info-v4`,
  GET_CERTIFIED_RAW_MATERIAL_CODES_V4:`${TE_TYPES.TCV4}/get-dtrackit-certified-raw-mat-codes-v4`,
  POST_PRODUCT_INFO_V4:`${TE_TYPES.TCV4}/post-product-info-v4`,
  //landing
  GET_TC_STANDARD_V4: `${TE_TYPES.TCV4}/get-tc-standard-v4`,
  GET_TC_NO_v4: `${TE_TYPES.TCV4}/get-tc-no-v4`,
  GET_CB_LANDING_PAGE_COUNTRIES_V4:`${TE_TYPES.TCV4}/get-buyer-country-v4`,
  EDIT_TC_DETAILS_V4: `${TE_TYPES.TCV4}/edit-tc-v4`,
  CERTIFIED_TRANSACTION_DASHBOARD_V4:`${TE_TYPES.TCV4}/get-cb-lic-code-v4`,
  //component
  COMPONENT_DETAILS_ENDPOINT_V4:`${TE_TYPES.TCV4}/post-component-detail-v4`,
  GET_COMPONENT_DETAILS_LIST_V4: `${TE_TYPES.TCV4}/get-list-component-detail-v4`,
  GET_COMPONENT_DETAIL_V4:`${TE_TYPES.TCV4}/get-component-detail-v4`,
  GET_TC_SC_COMPONENT_DETAILS_V4:`${TE_TYPES.TCV4}/get-tc-sc-component-details-v4`,
  GET_TC_COMPONENT_NET_SHIPPING_WEIGHT_V4:`${TE_TYPES.TCV4}/get-component-weight-calculation-v4`,
  //incoming TC Details
  POST_INCOMING_DETAIL_V4:`${TE_TYPES.TCV4}/post-incoming-tc-detail-v4`,
  GET_INCOMING_DETAIL_V4:`${TE_TYPES.TCV4}/get-incoming-tc-detail-v4`,
  GET_INCOMING_DETAIL_LIST_V4:`${TE_TYPES.TCV4}/get-list-incoming-tc-detail-v4`,
  GET_INTERMEDIATE_DATA_V4:`${TE_TYPES.TCV4}/get-intermediate-ledger-rm-data-v4`,
  GET_INTERMEDIATE_WEIGHT_V4:`${TE_TYPES.TCV4}/get-intermediate-ledger-weight-v4`,
  GET_SC_BY_TEID_STANDARD: `${TE_TYPES.TC}/get-sc-by-teid-standard`,
  GET_RMDF_SEARCH:`${TE_TYPES.TC}/get-rmdf-no`,
  GET_SC_PRODUCT_CLAIMS_CATEGORY_V4: `${TE_TYPES.TCV4}/get-sc-product-claims-category-v4`,
  //dtrackit
  GET_PRODUCT_CODE_V4:"PD",
  GET_STANDARD_LABEL_GRADE_V4:"LG",
  GET_PRODUCT_DETAIL_CODE_V4:"PDD",
  GET_RAW_MATERIAL_CODE_V4:"RM",
  GET_COUNTRY_CODE_V4:"CT",
  GET_STATE_CODE_V4:"ST",
  GET_METRIC_CODES: "PUM",
  //delete
  TC_DELETE_API_V4: `${TE_TYPES.TCV4}/delete-api-v4`,
  TC_SUBMIT_DATA_V4: `${TE_TYPES.TCV4}/post-save-data-v4`,
  //declarations
  PREVIEW_TC_V4: `${TE_TYPES.TCV4}/get-preview-tc-v4`,
  GENERATE_WORD_TC_V4: `${TE_TYPES.TCV4}/generate-word-tc-v4`,
  //PDF Upload
  TC_UPLOAD_PDF: `${TE_TYPES.TC}/upload-tc-pdf/`,
  //ML report 
  ML_OB_REPORT :`${TE_TYPES.ML}/get-ml-ob-report`,
  ML_LATEST_BAL: `${TE_TYPES.ML}/get-ml-latest-balance-report`,
  ML_OB_REPORT_EXPORT: `${TE_TYPES.ML}/download-ml-report`,
};
export const DELETECONFIG = {
  shipment: "Shipment",
  product: "Product",
  component: "Component",
  inputTc: "InputTC",
  inputTcComponent: "InputTcComponent",
};
